/**
 * @file: useSystemMetrics.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { useDeviceType } from '@euler/functions/useDeviceType';
import { getDefaultHeaderHeight } from '@react-navigation/elements';
import Constants from 'expo-constants';
import { DeviceType } from 'expo-device';
import { useRef } from 'react';
import { useWindowDimensions } from 'react-native';
import {
  useSafeAreaFrame,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

export const useSystemMetrics = () => {
  const safeAreaFrame = useSafeAreaFrame();
  const safeAreaInsets = useSafeAreaInsets();
  const windowDimensions = useWindowDimensions();
  const isMobileLayout = useIsMobileLayout();
  const deviceType = useDeviceType();
  const isTablet = deviceType === DeviceType.TABLET;
  const statusBarHeight = Constants.statusBarHeight;
  const navBarHeight = Math.max(
    getDefaultHeaderHeight(safeAreaFrame, false, statusBarHeight),
    isMobileLayout ? 0 : 64,
  );
  const maxNavBarHeight = useRef<number>(0);
  if (navBarHeight > maxNavBarHeight.current) {
    maxNavBarHeight.current = navBarHeight;
  }
  const maxSafeAreaTop = useRef<number>(0);
  if (safeAreaInsets.top > maxSafeAreaTop.current) {
    maxSafeAreaTop.current = safeAreaInsets.top;
  }
  return {
    statusBarHeight,
    navBarHeight,
    safeAreaFrame,
    safeAreaInsets,
    windowDimensions,
    deviceType,
    isTablet,
    isMobileLayout,
    maxSafeAreaTop: maxSafeAreaTop.current,
    maxNavBarHeight: maxNavBarHeight.current,
  };
};
